module.exports = __webpack_public_path__ + "00f50bcb4828bb397b220b8ba205f941.png";